<template>
  <div>
    <div class="systemsettings-wrap">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-card>
          <div slot="header" class="clearfix">
            <span style="font-weight:600;color:#000">固件上传操作</span>
          </div>
          <div>
            <div>
              <el-form-item label="固件SN编号"  style="margin-left:10px;width:400px">
                <el-input v-model="form.firmSN" placeholder="请输入固件SN号"></el-input>
                </el-form-item>
            </div>
            <div>
              <el-form-item label="版本号"  style="margin-left:10px;width:400px">
                <el-input v-model="form.version" placeholder="请输入版本号"></el-input>
                </el-form-item>
            </div>
            <div>
              <el-form-item label="选择项目"  style="margin-left:10px;width:400px">
              <el-button type="success" @click="selProject">点击选择项目</el-button>
                <span style="font-weight:600;color:#000">{{form.projectName}}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="固件备注信息"  style="margin-left:10px;width:400px">
                <el-input v-model="form.remark" placeholder="请输入固件备注信息"></el-input>
                </el-form-item>
            </div>
            <el-form-item label="固件选择"  style="margin-left:10px;width:400px">
              <el-upload
                ref="uploadBinFile"
                  class="avatar-uploader"
                  action=""
                  :limit=limitNum
                  :auto-upload="false"
                  accept=".bin"
                  :show-file-list="true"
                  :before-upload="beforeUploadFile"
                  :on-change="fileChange"
                  :on-exceed="exceedFile"
                  :file-list="fileList"
                  multiple
                >
                <el-button type="success" plain>选择文件</el-button>
                <div slot="tip" >只能上传(bin)文件，且单个文件大小不超过2M</div>
                </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="uploadFile">立即上传</el-button>
              <el-button class="resetbtn" @click="cancel" >取消</el-button>
            </el-form-item>
          </div>
        </el-card>
      </el-form>
    </div>
    <div v-show="showTable"  style="margin-top: 30px;width: 95%;margin-left:22px;">
      <STable
        ref="tableref"
        :url="url"
        :columns="columns"
        :handles="handles"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        labelWidth="120px"
      ></STable>
    </div>
  </div>
</template>

<script>
import { HOST } from "@/utils/host";
export default {
  name: "tongzhiguanli",
  components: {},
  data() {
    return {
      limitNum: 1,
      form: {
          firmSN:'',
          version:'',
          projectId:'',
          projectName:'',
          remark:"",
          fileList:[],
      },

      rules: {
      },
      showTable:false,
      isVisible:false,
      url: "/battery/ota/ProjectPage",
      columns: [
        {
          label: "项目名称q",
          prop: "name",
        },
        {
          label: "企业名称q",
          prop: "companyName",
        },
        {
          label: "创建人q",
          prop: "creatorName",
        },
        {
          label: "创建时间q",
          prop: "createTime",
        }
      ],
      // 操作栏
      handles: {
        width: 300,
        btns: [
          {
            label: "选择该项目",
            style: "color:#00CC00",
            handle: (resp) => {
              this.isVisible = false,
              this.showTable = false,
              this.form.projectId = resp.id,
              this.form.projectName = resp.name
             }
            //  this.$router.push({
            //    path: "./modifyProject",
            //    query: { data: resp },
            //  });
            //},
          },
        ],
      },
      query: [
        {
          label: "项目名称",
          prop: "name",
          placeholder: "请输入项目名称",
        },
        {
          label: "企业名称",
          prop: "companyName",
          placeholder: "请输入企业名称",
        }
      ],
    };
  },
  computed: {

  },
  methods: {
      getData(){
        this.$store.dispatch("form/handle",
        {
          url: "/battery/offline/query2",
          data: {},
          method: "get",
          callback: resp => {
              console.log("resp",resp)
          }
        });
    },


    beforeUploadFile(file) {

    },

    // 文件超出个数限制时的钩子
    exceedFile(files, fileList) {
      this.$notify.warning({
        title: '警告',
        message: `只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`
      });
    },

    fileChange(file, fileList) {
      console.log('change')
      let extension = file.name.substring(file.name.lastIndexOf('.')+1)
      let size= file.size / 1024 / 1024
      if(extension!="bin"){
        this.$message.error("上传文件格式不对!");
        console.log('formList')
        console.log(this.form.fileList)
         console.log('-----')
        this.$refs.uploadBinFile.clearFiles();
        file = null;
        fileList = []
        this.form.fileList = []
      }

      if(size>2){
        this.$message.error("上传文件不能大于2MB!");
      }

      if((extension=="bin")&&(size<=2))
      {
         this.form.fileList = fileList
         console.log(this.form.fileList)
      }
    },

    uploadFile(){
      let formData = new FormData()
      if((!this.form.firmSN)||(!this.form.projectId)||(!this.form.version)||(!this.form.remark)||(this.form.fileList.length<1))
      {
         this.$notify.error({
            title: "错误",
            message: '您漏填信息或未选上传文件',
          });
      }else{
        this.form.fileList.forEach(el =>{
          formData.append('file',el.raw)
        })
        formData.append('firmSN',this.form.firmSN)
        formData.append('projectId',this.form.projectId)
        formData.append('projectName',this.form.projectName)
        formData.append('version',this.form.version)
        formData.append('remark',this.form.remark)
        this.$store.dispatch("form/handle", {
          url: "/battery/ota/uploadFiles0",
          data: formData,
          method: "post",
          callback: resp => {
              this.$notify({
              title: "成功",
              message: "上传文件完成",
              type: "success"
              });
              this.form.fileList = []
              this.$refs.uploadBinFile.clearFiles();
              this.$refs.file = null
              this.$refs.fileList = []
          }
        })
      }
    },
    selProject()
    {

        console.log("--click 22")
        this.isVisible = true,
        this.showTable = true,
        //this.$router.push('/findProject')
        console.log("--click 33")
        //this.$router.push({
        //  path: "/projectManagement",
        //  query: { data: 2 },
        //});
    },
    async submit(){
        try {
            await Promise.all([
                this.$refs.issueForm.validate(),
            ]);
        } catch (error) {
            return;
        }
      let param = {
        deviceID: this.currentDeviceId,
        command: this.issueForm.command
      }
      this.$store.dispatch("form/handle", {
        url: "/battery/dcDevice/command",
        data: param,
        method: "post",
        callback: (resp) => {
          this.$notify({
            title: "成功",
            message: "下发指令成功",
            type: "success"
          });
          this.issueDialogVisible = false;
        },
      });
    },


  },
  mounted() {
  },
  created() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {
    this.getData()
  }, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
.btn {
  width: 600px;
  height: 50px;
  margin-top: 10px;
  margin-left: 40%;
}
.resetbtn:hover {
  border: 1px solid #00cc00;
  color: #00cc00
}
.resetbtn:active {
  border: 1px solid #00cc00;
  color: #ffffff;
  background-color:#00cc00;
}
.systemsettings-wrap /deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color:#000000;
}
.systemsettings-wrap /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #8a8686;
  border-color: #8a8686;
}

.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.formcss{
  float: left;
   .el-form-item {
        margin-bottom: 10px;
    }
}
.fields {
      float: left;

      width: 80%;
      .general {
      }
      .advanced {
      }
      .el-form-item {
        margin-bottom: 10px;
      }
    }
#container {
  width: 500px;
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/BMS/firmManagement/firmUpload.vue